var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "c502cb49-546f-4adf-8d7d-aa65b77a8994"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "253aafc8-f4a2-48de-a19f-2ede7d8a4b94"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.82 0 0 0.82 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 106.42 -113.03)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-4973.14, -5010.93)",
    d: "M 6940 8317 C 6914 8310 6878 8294 6860 8283 C 6810 8252 2215 3651 2197 3615 C 2189 3599 2065 3232 1921 2800 C 1634 1937 1638 1952 1684 1855 C 1710 1799 1774 1736 1828 1713 C 1915 1677 1919 1678 2760 1959 C 3192 2103 3560 2229 3578 2238 C 3596 2248 4652 3297 5926 4570 C 7639 6283 8246 6897 8263 6930 C 8294 6993 8293 7097 8261 7160 C 8245 7191 8074 7370 7707 7738 C 7145 8301 7132 8312 7030 8324 C 7005 8327 6965 8324 6940 8317 z M 7322 7363 C 7492 7193 7630 7051 7630 7045 C 7630 7040 7489 6894 7318 6723 L 7005 6410 L 6693 6722 C 6521 6894 6380 7040 6380 7046 C 6380 7058 6995 7670 7007 7670 C 7011 7670 7153 7532 7322 7363 z M 6310 6345 L 6625 6030 L 4962 4367 L 3300 2705 L 2830 2548 C 2571 2462 2360 2396 2360 2402 C 2360 2407 2430 2622 2515 2878 L 2671 3345 L 4328 5003 C 5239 5914 5987 6660 5990 6660 C 5993 6660 6137 6518 6310 6345 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.13 0 0 -0.13 0 16.38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-4174.98, -4040.35)",
    d: "M 1005 8069 C 848 8046 665 7974 524 7880 C 431 7817 283 7672 218 7580 C 156 7492 88 7353 55 7250 C -3 7064 0 7232 0 4046 C 0 818 -4 1012 62 816 C 178 466 463 178 805 66 C 1005 1 719 6 4100 2 C 6325 0 7196 2 7278 10 C 7494 32 7671 96 7842 217 C 8048 361 8209 577 8288 816 C 8351 1005 8350 974 8350 2533 C 8350 3933 8350 3950 8330 4004 C 8307 4065 8245 4129 8183 4156 C 8127 4180 8025 4177 7967 4150 C 7915 4125 7856 4066 7832 4011 C 7816 3978 7815 3845 7810 2515 L 7805 1055 L 7775 975 C 7699 774 7548 629 7350 568 L 7275 545 L 4170 545 L 1065 545 L 985 572 C 791 638 646 782 572 982 L 545 1055 L 542 4008 C 540 7291 534 7029 609 7184 C 680 7331 814 7451 972 7508 L 1045 7535 L 2595 7540 C 4142 7545 4145 7545 4190 7566 C 4247 7593 4312 7663 4335 7723 C 4373 7823 4338 7949 4253 8019 C 4174 8084 4281 8080 2596 8079 C 1754 8078 1038 8074 1005 8069 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.7229d5745b2423ea6df050b800175e3f.svg";
export { ForwardRef as ReactComponent };